import { render, staticRenderFns } from "./SimpleButtonGroup.vue?vue&type=template&id=a6cc51b8&"
import script from "./SimpleButtonGroup.vue?vue&type=script&lang=js&"
export * from "./SimpleButtonGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports